import * as accountActions from '../actions/account';

const initialState = {
    account: {},
    isLoadingAccountDetails: false,
    authMethodSetupShowing: false,
    authSetupSuccessful: false
};

export default (state = initialState, action) => {
    switch (action.type) {

        case accountActions.REFRESH_ACCOUNT_RECEIVED:
            return {
                ...state,
                account: action.account
            };

        case accountActions.ACCOUNT_IS_LOADING:
            return {
                ...state,
                isLoadingAccountDetails: action.isLoading
            };

        case accountActions.SHOWING_AUTH_METHOD_SETUP:
            return {
                ...state,
                authMethodSetupShowing: action.method
            };

        case accountActions.AUTH_SETUP_SUCCESS:
            return {
                ...state,
                authSetupSuccessful: action.isSuccessful
            }

        default:
            return state;
    }
};